import { CommonTokens } from './type';

const common: CommonTokens = {
  lineHeightDynamic: 'Line-height-dynamic',
  lineHeightDynamicMin: 'Line-height-dynamic-min',
  defaultBorder: 'Border-1',
  iconCirclePadding: 'Padding-4',
  transparent: 'transparent',
  backgroundPopup: 'Background-popup',
  backgroundLayout: 'Background-layout',
};

export default common;
